/**
 * Favorite Validation Schema
 * Zod schemas for runtime validation of favorite operations
 */

import { z } from "zod";

export const createFavoriteSchema = z.object({
  resultId: z.number().int().positive("Result ID must be a positive integer"),
});

export const deleteFavoriteSchema = z.object({
  id: z.number().int().positive("Favorite ID must be a positive integer"),
});

export const getFavoritesByResultSchema = z.object({
  resultId: z.number().int().positive("Result ID must be a positive integer"),
});

export type CreateFavoriteInput = z.infer<typeof createFavoriteSchema>;
export type DeleteFavoriteInput = z.infer<typeof deleteFavoriteSchema>;
export type GetFavoritesByResultInput = z.infer<typeof getFavoritesByResultSchema>;
